module.exports = __webpack_public_path__ + "static/media/enelGreenPowerLogo.f3a72de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/enelGreenPowerLogo.png
// module id = 1753
// module chunks = 0